import {appUrl} from "../helpers";

export function initGlobalOrderSearch() {
  $('#global-order-search').kendoComboBox({
    placeholder: "Objednávka ...",
    filter: "contains",
    autoBind: false,
    minLength: 3,
    delay: 400,
    highlightFirst: false,
    dataTextField: "number",
    dataValueField: "id",
    template: '<span class="k-state-default"><strong>#: data.number # <small>#: data.status #</small></strong><br />#: data.invoice_customer_name #<br /><em>#: data.invoice_email #</em><br><small>#: data.shop_name #</small></small></span>',
    dataSource: {
      serverFiltering: true,
      transport: {
        read: {
          xhrFields: {
            withCredentials: true
          },
          url: appUrl('eshop') + '/order/order-search/search',
          dataType: "json"
        },
        cache: true
      }
    },
    select: function (e) {
      if (typeof e.dataItem === 'undefined') {
        return;
      }

      window.open(e.dataItem.url, '_blank')
    },
  });
}